import * as React from 'react';
import Layout from '../components/Layout';
import OpinionsFromUsers from '../components/OpinionsFromUsers';
import Header from '../components/Header';
// import IframeMeeting from '../components/IframeMeeting';
import Footer from '../components/Footer';
import Carousel from '../components/Carousel';
import LanguageSwitcher from '../components/LanguageSwitcher';
import DynamicBoxes from '../components/DynamicBoxes';
import { useTranslation } from 'react-i18next';
import FAQ from '../components/FAQ';

export default function ClubsPage() {
  const { t, i18n } = useTranslation();

  const featuresData = [
    {
      gridSize: 6,
      title: t("ClubsPage00"),
      description: t("ClubsPage01"),
    },
    {
      gridSize: 6,
      title: t("ClubsPage02"),
      description: t("ClubsPage03"),
    },

    {
      gridSize: 6,
      title: t("ClubsPage18"),
      description: t("ClubsPage19"),
    },

    {
      gridSize: 6,
      title: t("ClubsPage20"),
      description: t("ClubsPage21"),
    },
    {
      gridSize: 12,
      title: t("ClubsPage04"),
      description: t("ClubsPage05"),
    },

  ];

  return (
    <Layout>
      <Header />

      {/* <TextDescriptionSideImage
        titleText={t("ClubsPage08")}
        descriptionText={t("ClubsPage09")}
        videoSrc={getVideoSrc('clubsCalendar', i18n.language)}
      />

      <Divider marginTop={{ xs: 5, sm: 10 }} marginBottom={{ xs: 5, sm: 10 }} /> */}

      <DynamicBoxes
        mainTitleOrange={t("ClubsPage10")}
        mainTitleWhite={t("ClubsPage11")}
        features={featuresData} />

      {/* <div id="igrameeting">
        <IframeMeeting />
      </div> */}
      <Carousel />
      <OpinionsFromUsers />
      <FAQ />
      <Footer />
      <LanguageSwitcher />
    </Layout>
  );
}